const lotteryBannerUrls = [
	'https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-05-20/1b095d6c421109db2e2d0fd9f1cefc0f.png',
	'https://cdn-xcx-qunsou.weiyoubot.cn/material/2026-07-17/dda883dd182df9f9ce9ffc489820d4fd.png',
];

export const getRandomLotteryBanner = () => lotteryBannerUrls[Math.floor(Math.random() * lotteryBannerUrls.length)];
